import React, { Component } from 'react';

import styled, { css } from 'styled-components';
import { Collapse } from 'react-collapse';
import MaterialIcon from 'material-icons-react';
import Icons from 'components/Icons';
import Theme from 'Theme';

export class PendingFile extends Component {
  render() {
    const { file, description, onFileDelete } = this.props;

    const filename = !!file && (file.name || '');

    return (
      <FileContain isOpened={!!file}>
        <Collapse isOpened={!!file}>
          <ItemContain>
            <Flex>
              <IconOffset>
                <Icons.Order color={'rgb(24, 146, 220)'} size={42} />
              </IconOffset>
              <Text>
                <PrimaryLine>{description || filename}</PrimaryLine>
                <SecondaryLine>{filename}</SecondaryLine>
              </Text>
              <Cancel onClick={onFileDelete}>
                <MaterialIcon
                  icon="remove_circle_outline"
                  color={Theme.inactiveColor}
                  size="small"
                />
              </Cancel>
            </Flex>
          </ItemContain>
        </Collapse>
      </FileContain>
    );
  }
}

const FileContain = styled.div`
  line-height: ${(props) => props.isOpened && containOpen};
`;

const containOpen = css`
  margin-bottom: 20px;
  margin-top: 16px;
`;

const IconOffset = styled.div`
  position: relative;
  top: 4px;
`;

const ItemContain = styled.div`
  border-style: solid;
  border-width: 1px;
  border-color: rgba(245, 245, 245, 1);
  margin-right: 4px;
  border-radius: 4px;
`;

const Flex = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-direction: row;
  line-height: 1.5em;
  padding: 1.5em 1em;
`;

const Text = styled.div`
  flex: 1;
  margin-left: 16px;
  font-family: ${Theme.primaryFont};
`;

export const PrimaryLine = styled.div`
  font-family: Roboto;
  font-weight: 500;
  font-size: 1em;
  color: rgb(0, 118, 190);
`;

export const SecondaryLine = styled.div`
  font-size: 0.875em;
  font-color: #333;
  font-family: Roboto;
  font-weight: 300;
  color: #333;
`;

const Cancel = styled.div`
  cursor: pointer;

  i {
    transition: all 250ms ease-in-out;
    -webkit-transition: all 250ms ease-in-out;
  }

  &:hover i {
    color: ${Theme.dangerColor} !important;
  }
`;

export default PendingFile;
